import { Goal } from '@griply/types';

import { getCompletionPercentage } from './get-completion-percentage';
import { getGoalCompletion } from './get-goal-completion';

export const hasGoalReachedTarget = (goal: Goal, goals: Goal[]): boolean =>
  getCompletionPercentage(getGoalCompletion(goal, { goals })) >= 100;
